import script from "./auditModal.vue?vue&type=script&setup=true&lang=js"
export * from "./auditModal.vue?vue&type=script&setup=true&lang=js"

import "./auditModal.vue?vue&type=style&index=0&id=37aea90e&lang=less&scoped=true"

import exportComponent from "/root/workspace/dsx-frontend_gib7/h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37aea90e"]])

export default __exports__